<template>
  <header :style="{ maxWidth: width }">
    <slot />
  </header>
</template>

<script setup>
defineProps({
  width: String,
})
</script>

<style lang="scss" scoped>
header {
  text-align: center;
  font-size: 32px;
  font-weight: 600;
  line-height: 40px;
  color: $blue-500;

  &::v-deep(em) {
    font-weight: 600;
    font-style: normal;
    color: $brand-secondary;
  }
}
</style>
